import { useState, useCallback, useEffect } from "react";
import axios from "axios";
import { toast } from "react-toastify";

const API_BASE_URL =
  "https://dev.oliveeb.com/olitask-service/api/v1/donations/donor";

export default function useDonorDonations(
  authToken,
  donorId,
  page = 0,
  pageSize = 10
) {
  const [donations, setDonations] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // pagination state
  const [totalPages, setTotalPages] = useState(1);
  const [totalElements, setTotalElements] = useState(0);

  // handle axios errors
  const handleAxiosErrors = (err, action = "operation") => {
    let message = "An unexpected error occurred.";
    if (err.response) {
      message =
        err.response.data?.message ||
        `Failed to ${action}: ${err.response.statusText}`;
    } else if (err.request) {
      message =
        "No response from the server. Please check your internet connection.";
    } else {
      message = err.message || "Something went wrong.";
    }
    setError(message);
    toast.error(message);
    console.error(`${action} error:`, err);
  };

  // Fetch all donations of a given donor
  const fetchDonorDonations = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const res = await axios.get(
        `${API_BASE_URL}/${donorId}?page=${page}&size=${pageSize}`,
        {
          headers: { Authorization: `Bearer ${authToken}` },
        }
      );
      const data = res.data;
      setDonations(data.content);
      setTotalPages(data.totalPages || 1);
        setTotalElements(data.totalElements || 0);
        console.log("Response", data.content);
      //   return data.content;
    } catch (err) {
      handleAxiosErrors(err, "Fetch donor donations");
    } finally {
      setLoading(false);
    }
  }, [authToken, donorId, page, pageSize]);

  // fetch automatically when donor id changes
  useEffect(() => {
    if (authToken) fetchDonorDonations();
  }, [authToken, donorId, fetchDonorDonations]);

  return {
    donations,
    loading,
    error,
    totalPages,
    totalElements,
  };
}
